// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"64cc3bb0","312":"d89eff12"}[chunkId] + ".chunk.js";
};